import './Localization.css'
export default function Localization(){
    return(
        <>
              <iframe 
              className="localization" 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d465.9042090941919!2d-48.2270908104445!3d-15.937863316805458!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x935bd08ec038b1d5%3A0x37ecbd7bbeda96e9!2sNetSim%20Telecom.!5e0!3m2!1spt-BR!2sbr!4v1702044059509!5m2!1spt-BR!2sbr" 
              frameBorder="0" 
              allowFullScreen loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade">

              </iframe>

        </>
    )
}